var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFuerzaOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ff7f00;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-fuerza-off") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_15",
    "data-name": 15
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17.09 121.36 17.09 133.82 132.43 133.82 108 121.36 17.09 121.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "190.35 149.38 135.42 121.36 108 121.36 133.92 121.36 133.92 133.82 132.43 133.82 180.43 158.31 190.35 149.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "133.92 121.36 108 121.36 132.43 133.82 133.92 133.82 133.92 121.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.82,157.19A21.6,21.6,0,0,0,98.27,148a21.84,21.84,0,0,0-41.07,9.15c0,.37,0,.74,0,1.12a21.84,21.84,0,1,0,43.67,0C100.85,157.93,100.84,157.56,100.82,157.19ZM79,172.3a14,14,0,0,1-14-14c0-.38,0-.75,0-1.12a14,14,0,0,1,27.88,0c0,.37,0,.74,0,1.12A14,14,0,0,1,79,172.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.84,133.82a24.8,24.8,0,0,1,10.29,10.23A24.35,24.35,0,0,1,108,154.39c0,.42,0,.85,0,1.27a25.25,25.25,0,0,1-.14,2.62h22.75V133.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,155.66c0-.42,0-.85,0-1.27a24.35,24.35,0,0,1,2.87-10.34,24.8,24.8,0,0,1,10.29-10.23H17.09v24.46h33A25.25,25.25,0,0,1,50,155.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.94 133.82 41.48 133.82 46.27 121.36 58.73 121.36 53.94 133.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28.81 133.82 16.35 133.82 21.14 121.36 33.6 121.36 28.81 133.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.5 133.82 67.04 133.82 71.83 121.36 84.29 121.36 79.5 133.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.78 133.82 92.32 133.82 97.12 121.36 109.58 121.36 104.78 133.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.34 133.82 117.88 133.82 122.68 121.36 135.14 121.36 130.34 133.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.71 141.11 135.6 135.46 145.53 126.53 156.63 132.18 146.71 141.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.49 152.71 158.38 147.05 168.31 138.12 179.41 143.78 169.49 152.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.69,43.81H100.3V77.7H86.84l8.48,8.76,15,15.44,3.71,3.83,3.71-3.83,15-15.44,8.49-8.76H127.69V43.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFuerzaOff);
export default __webpack_public_path__ + "static/media/ic-fuerza-off.679c99cd9fed28bab4ceea8a97da43ae.svg";
export { ForwardRef as ReactComponent };